import { render, staticRenderFns } from "./DeliveryAddressPopup.vue?vue&type=template&id=03f8fe09&scoped=true&"
import script from "./DeliveryAddressPopup.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressPopup.vue?vue&type=style&index=0&id=03f8fe09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8fe09",
  null
  
)

export default component.exports